import { SVGProps } from "react"
const DocIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 13.9V16.9C17 20.9 15.4 22.5 11.4 22.5H7.6C3.6 22.5 2 20.9 2 16.9V13.1C2 9.1 3.6 7.5 7.6 7.5H10.6"
      stroke="#2768A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9996 13.9H13.7996C11.3996 13.9 10.5996 13.1 10.5996 10.7V7.5L16.9996 13.9Z"
      stroke="#2768A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.5996 2.5H15.5996" stroke="#2768A3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7 5.5C7 3.84 8.34 2.5 10 2.5H12.62"
      stroke="#2768A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9995 8.5V14.69C21.9995 16.24 20.7395 17.5 19.1895 17.5"
      stroke="#2768A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 8.5H19C16.75 8.5 16 7.75 16 5.5V2.5L22 8.5Z"
      stroke="#2768A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default DocIcon
